import { render, staticRenderFns } from "./EntrepreneurshipsAssigned.vue?vue&type=template&id=2c0f8ca3"
import script from "./EntrepreneurshipsAssigned.vue?vue&type=script&lang=js"
export * from "./EntrepreneurshipsAssigned.vue?vue&type=script&lang=js"
import style0 from "./EntrepreneurshipsAssigned.vue?vue&type=style&index=0&id=2c0f8ca3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports